import {Utilities} from "../utilities";
import Axios from "axios";

export class Posts {

  /**
   * Constructor.
   */
  constructor() {
    this.postCategoryForm = document.getElementById("post-category-form");
    this.categorySelect = document.getElementById("post-category-select");
    this.postsRow = document.getElementById("posts-row");
    this.postSearchForm = document.getElementById("post-text-search-form");
    this.postSearchInput = document.getElementById("post-text-search-input");
    this.postSearchAutoLoad = document.getElementById('post-search-auto-load');
    this.postSearchButton = document.getElementById("post-search-button");
    this.nextPage = 1;

    this.setEventListeners();
    console.log(this.postSearchType);
    if (this.postSearchAutoLoad === null || this.postSearchAutoLoad.value === "1") {
      this.loadPosts("category-search");
    }
  }

  /**
   * Set all of our event listeners.
   */
  setEventListeners() {
    const _self = this;

    // Prevent post category form from submitting.
    if (_self.postCategoryForm !== null) {
      _self.postCategoryForm.addEventListener("submit", function (e) {
        e.preventDefault();
      });
    }

    // On select change, load in the blog posts.
    if (_self.categorySelect !== null) {
      _self.categorySelect.addEventListener("change", function (e) {
        e.preventDefault();
        _self.nextPage = 1;
        _self.postsRow.innerHTML = "";
        _self.updateInputDisabledState(true);
        _self.postSearchType = "category-search";

        _self.loadPosts(_self.postSearchType);

        // Reset text search value.
        if (_self.postSearchInput !== null) {
          _self.postSearchInput.value = "";
        }
      });
    }

    // Prevent post search form from submitting.
    if (_self.postSearchForm !== null) {
      _self.postSearchForm.addEventListener("submit", function (e) {
        e.preventDefault();
      });
    }

    // On search click, get blogs from server and append to dom.
    if (_self.postSearchButton !== null) {
      let postSearchType = document.getElementById('post-search-type') === null ? "text-search" : document.getElementById('post-search-type').value;
      _self.postSearchButton.addEventListener("click", function (e) {
        e.preventDefault();

        // Workaround to prevent the insight category pages from loading posts twice.
        // This changes posts-row-init to posts-row before submitting anything so that
        // the callback can put the elements where they belong.
        if (document.getElementById('posts-row-init')) {
          document.getElementById('posts-row-init').id = 'posts-row';
          _self.postsRow = document.getElementById("posts-row");
        }

        _self.nextPage = 1;
        _self.postsRow.innerHTML = "";
        _self.updateInputDisabledState(true);
        _self.loadPosts(postSearchType);

        // Reset category select value.
        if (_self.categorySelect !== null && postSearchType !== "both-search") {
          _self.categorySelect.value = "";
        }
      });
    }
  }

  /**
   * Get posts, makes server side get request.
   */
  loadPosts(searchType) {
    const _self = this;
    let category_id = null;
    let text_search = null;

    if (_self.canBePostsPage() === false) {
      return;
    }

    // Make sure correct search type is set.
    if ((searchType === "category-search" || searchType === "text-search" || searchType === "both-search") === false) {
      return;
    }

    if (_self.categorySelect !== null) {
      category_id = (_self.categorySelect.value !== "") ? _self.categorySelect.value : null;
    }

    if (_self.postSearchInput !== null) {
      text_search = (_self.postSearchInput.value !== "") ? _self.postSearchInput.value : "";
    }

    Utilities.showLoader();

    Axios({
      method: 'get',
      url: wp.ajax_url,
      params: {
        action: "kb_get_posts",
        page: parseInt(_self.nextPage),
        category: parseInt(category_id),
        text: text_search,
        type: searchType
      }
    }).then(function (response) {
      console.log(response);
      _self.postsRow.innerHTML += response.data;
      _self.bindLoadMore();
      Utilities.hideLoader();

      if (_self.categorySelect !== null) {
        _self.updateInputDisabledState(false);
      }
    }).catch(function (error) {
      console.log(error);
      Utilities.hideLoader();
    });
  }

  /**
   * Bind load more button.
   */
  bindLoadMore() {
    const _self = this;
    const loadMore = document.getElementById("posts-load-more");
    if (loadMore === undefined || loadMore === null) {
      return;
    }
    let nextPage = loadMore.dataset.nextPage;
    let totalPosts = loadMore.dataset.totalPosts;
    let type = loadMore.dataset.type;

    if (nextPage === undefined || totalPosts === undefined || type === undefined) {
      return;
    }

    _self.nextPage = parseInt(nextPage);

    // Check if we have loaded all of the posts and if so get rid of the load more button.
    if (_self.postsRow.childElementCount >= totalPosts) {
      loadMore.parentElement.parentElement.parentElement.remove();
      return;
    }

    loadMore.addEventListener("click", function (e) {
      e.preventDefault();
      _self.loadPosts(type);
      loadMore.parentElement.parentElement.parentElement.remove();
    });
  }

  /**
   * Update the disabled state of the inputs. Makes it simpler to disable enable all inputs.
   *
   * @param disabledState
   */
  updateInputDisabledState(disabledState) {
    if (this.categorySelect !== null) {
      this.categorySelect.disabled = disabledState;
    }

    if (this.postSearchInput !== null) {
      this.postSearchInput.disabled = disabledState;
    }

    if (this.postSearchButton !== null) {
      this.postSearchButton.disabled = disabledState;
    }
  }

  /**
   * Check if the page loaded can be the teams page by checking if certain elements are present.
   *
   * The required items are:
   *  - If an element with an id of "team-members-row" exists.
   * @returns {boolean}
   */
  canBePostsPage() {
    const _self = this;
    let canBePostsPage = true;

    if (_self.postsRow === null) {
      canBePostsPage = false;
    }

    return canBePostsPage;
  }
}

const posts = new Posts();